// Cupons desta loja são independentes dos cupons de assinatura do Print Control.
export const normalizarCodigoCupomLoja = (codigo) => String(codigo || "").trim().toUpperCase();

export function dataCupomBrasilia(valor) {
  const data = new Date(valor || "");
  if (!Number.isFinite(data.getTime())) return "";
  const partes = new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Sao_Paulo", year: "numeric", month: "2-digit", day: "2-digit",
  }).formatToParts(data);
  const campo = (tipo) => partes.find((parte) => parte.type === tipo)?.value;
  return `${campo("year")}-${campo("month")}-${campo("day")}`;
}

export function fimDoDiaCupomBrasilia(data) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(data || "")) return null;
  const verificar = new Date(`${data}T12:00:00.000Z`);
  if (!Number.isFinite(verificar.getTime()) || verificar.toISOString().slice(0, 10) !== data) return null;
  // Brasil não usa horário de verão: a validade termina às 23:59:59 de Brasília.
  return new Date(`${data}T23:59:59.999-03:00`).toISOString();
}

export function validarFormularioCupomLoja(formulario, agora = Date.now()) {
  const codigo = normalizarCodigoCupomLoja(formulario.codigo);
  if (!/^[A-Z0-9_-]{3,40}$/.test(codigo)) {
    return { erro: "Use de 3 a 40 letras, números, hífen ou sublinhado no código." };
  }
  const tipo = formulario.tipo;
  const valor = Number(String(formulario.valor ?? "").trim().replace(",", "."));
  if (!["percentual", "fixo"].includes(tipo) || !Number.isFinite(valor) || valor <= 0) {
    return { erro: "Informe um desconto maior que zero." };
  }
  if (tipo === "percentual" && valor > 100) return { erro: "O desconto percentual deve ser de até 100%." };
  if (tipo === "fixo" && valor > 1000000) return { erro: "O desconto em reais deve ser de até R$ 1.000.000,00." };
  const valorArredondado = Math.round((valor + Number.EPSILON) * 100) / 100;
  if (!valorArredondado) return { erro: "O desconto mínimo é 0,01." };
  const minimo = String(formulario.valorMinimo ?? "").trim().replace(",", ".");
  if (minimo && (!/^\d+(\.\d{1,2})?$/.test(minimo) || Number(minimo) > 1000000)) {
    return { erro: "Informe uma compra mínima entre R$ 0,00 e R$ 1.000.000,00, com até duas casas decimais." };
  }
  const valorMinimo = Math.round((Number(minimo) + Number.EPSILON) * 100) / 100;
  const maximo = String(formulario.descontoMaximo ?? "").trim().replace(",", ".");
  if (maximo && (!/^\d+(\.\d{1,2})?$/.test(maximo) || Number(maximo) > 1000000)) {
    return { erro: "Informe um desconto máximo entre R$ 0,00 e R$ 1.000.000,00, com até duas casas decimais." };
  }
  const descontoMaximo = Math.round((Number(maximo) + Number.EPSILON) * 100) / 100;
  const expiraEm = fimDoDiaCupomBrasilia(formulario.validade);
  if (!expiraEm || new Date(expiraEm).getTime() <= agora) {
    return { erro: "Escolha uma data de validade a partir de hoje." };
  }
  return { dados: { codigo, tipo, valor: valorArredondado, valorMinimo, descontoMaximo, expiraEm, ativo: formulario.ativo === true } };
}

export function statusCupomLoja(cupom, agora = Date.now()) {
  if (!cupom.ativo) return "Pausado";
  const validade = new Date(cupom.expiraEm || "").getTime();
  if (!Number.isFinite(validade) || validade <= agora) return "Expirado";
  return "Ativo";
}
